/*
  Two small brand touches (see snippets/yazne-delight.liquid): the chrome star that flies to the cart on add, and the
  silver sparkles that trail a mouse over product photos. Loaded with defer so browsers cache it.
*/
(function () {
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  // Same shape and chrome as the cart count star below, so the hand-off on landing is seamless.
  var STAR = '<svg viewBox="0 0 24 24" aria-hidden="true"><defs><linearGradient id="yzS" x1=".2" y1="0" x2=".8" y2="1">' +
    '<stop offset="0" stop-color="#FFFFFF"/><stop offset=".34" stop-color="#DADDE0"/><stop offset=".68" stop-color="#9AA0A7"/><stop offset="1" stop-color="#EEF0F1"/></linearGradient></defs>' +
    '<path fill="url(#yzS)" stroke="#3D4248" stroke-width=".6" stroke-linejoin="round" d="M12 .8l3.3 6.9 7.5.9-5.5 5.2 1.4 7.5L12 17.6l-6.7 3.7 1.4-7.5L1.2 8.6l7.5-.9z"/></svg>';
  // Silver that reads on the pearl photo backdrop: light centre, darker steel edge.
  var SPARK = '<svg viewBox="0 0 24 24" aria-hidden="true"><defs><radialGradient id="yzK"><stop offset="0" stop-color="#FFFFFF"/><stop offset=".55" stop-color="#B7BCC2"/><stop offset="1" stop-color="#7A7F86"/></radialGradient></defs>' +
    '<path fill="url(#yzK)" stroke="#4A4F56" stroke-width=".9" d="M12 1c.8 6 5 10.2 11 11-6 .8-10.2 5-11 11-.8-6-5-10.2-11-11 6-.8 10.2-5 11-11z"/></svg>';

  function make(cls, svg) {
    var el = document.createElement('div');
    el.className = cls;
    el.setAttribute('aria-hidden', 'true');
    el.innerHTML = svg;
    document.body.appendChild(el);
    return el;
  }
  function visible(el) {
    if (!el) return null;
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0 && r.bottom > 0 && r.top < window.innerHeight ? r : null;
  }

  /* 1. Star to cart ---------------------------------------------------------------------- */
  var ADD = 'button[name="add"], [data-yazne-add-btn], .add-to-cart-button, add-to-cart-component button, .quick-add__button, form[action*="/cart/add"] [type="submit"]';
  var lastPress = null;
  var lastFlight = 0;
  document.addEventListener('pointerdown', function (e) {
    var btn = e.target.closest && e.target.closest(ADD);
    if (btn) lastPress = { rect: btn.getBoundingClientRect(), x: e.clientX, y: e.clientY, at: Date.now() };
  }, { capture: true, passive: true });

  // The star replaces the theme's own "fly to cart" dot. It leaves the button at the same moment the
  // dot would (on click), lands exactly on the cart count star and becomes it. The new count, the
  // bump and the twinkle wait for both things: the landing and the store confirming the add. If
  // the store answers later than the landing, the star simply rests on the cart until it does.
  var flight = null; // { icon, star, landed, confirmed, done }
  var lastReveal = 0;
  var phone = window.matchMedia('(max-width: 989px)'); // cart drawer covers the header there
  var SPRING = 'cubic-bezier(0.34, 1.4, 0.64, 1)';
  // The count star settles with a small spring and the number fades up into it (this replaces the
  // theme's own shrink-and-grow, which read as a blink).
  function softPop(icon) {
    if (reduced.matches) return;
    var bubble = icon.querySelector('.cart-bubble');
    var text = icon.querySelector('.cart-bubble__text');
    if (bubble) bubble.animate([{ scale: 1 }, { scale: 1.14 }, { scale: 1 }], { duration: 460, easing: SPRING });
    if (text) text.animate([{ opacity: 0, translate: '0 3px' }, { opacity: 1, translate: '0 0' }], { duration: 260, delay: 60, easing: 'ease-out', fill: 'backwards' });
  }
  function reveal(f) {
    if (f.done) return;
    f.done = true;
    lastReveal = Date.now();
    clearTimeout(f.safety);
    if (flight === f) flight = null;
    var icon = f.icon;
    if (f.breath) f.breath.cancel();
    // The real count star appears under the flying one (identical), which then melts away.
    icon.classList.remove('yz-await');
    var out = f.star.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 180, easing: 'ease-out', fill: 'forwards' });
    out.onfinish = function () { f.star.remove(); };
    // (yazne-overrides skips its own twinkle while .yz-spark is on.)
    icon.classList.add('yz-spark', 'yz-spark2');
    setTimeout(function () { icon.classList.remove('yz-spark', 'yz-spark2'); }, 900);
    softPop(icon);
  }
  // The store confirmed the add (the theme updated the count).
  function confirmed() {
    if (flight) {
      flight.confirmed = true;
      if (flight.landed) reveal(flight);
      return;
    }
    // No star in the air yet (e.g. an add without the theme's dot, like the configurator): fly now.
    var f = flyToCart();
    if (f) { f.confirmed = true; return; }
    // No flight possible (phone, cart icon off screen): just the soft settle. Skipped right after a
    // landing, since the configurator announces each add twice (its own event + the count update).
    if (Date.now() - lastReveal < 1500) return;
    var icon = document.querySelector('cart-icon');
    if (icon) softPop(icon);
  }
  function flyToCart() {
    if (reduced.matches || phone.matches || flight || !lastPress || Date.now() - lastPress.at > 10000) return null;
    if (Date.now() - lastFlight < 1200) return null;
    var icon = document.querySelector('cart-icon');
    var to = visible(icon);
    if (!to || !document.body.animate) return null;
    lastFlight = Date.now();
    var x0 = lastPress.x || lastPress.rect.left + lastPress.rect.width / 2;
    var y0 = lastPress.y || lastPress.rect.top + lastPress.rect.height / 2;
    lastPress = null;
    // Where the count star sits: top-right corner of the icon (same variables the theme uses).
    var cs = getComputedStyle(icon);
    var size = parseFloat(cs.getPropertyValue('--cart-bubble-size')) || 20;
    var x1 = to.right - (parseFloat(cs.getPropertyValue('--cart-bubble-right')) || 0) - size / 2;
    var y1 = to.top + (parseFloat(cs.getPropertyValue('--cart-bubble-top')) || 0) + size / 2;
    var dx = x1 - x0;
    var lift = Math.min(150, Math.max(60, Math.abs(dx) * 0.22));
    icon.classList.add('yz-await');
    var star = make('yz-fly', STAR);
    // One continuous arc (quadratic curve) sampled densely with a single smooth ease, so speed
    // never jumps: it lifts off, glides and slows into the landing. Scale and spin follow the
    // same clock.
    var cx = x0 + dx * 0.3, cy = Math.min(y0, y1) - lift;
    var endScale = size / 26;
    var ease = function (t) { var s = t * t * (3 - 2 * t), o = 1 - Math.pow(1 - t, 3); return 0.45 * s + 0.55 * o; };
    var frames = [], N = 32;
    for (var k = 0; k <= N; k++) {
      var t = k / N, u = ease(t), m = 1 - u;
      var x = m * m * x0 + 2 * m * u * cx + u * u * x1;
      var y = m * m * y0 + 2 * m * u * cy + u * u * y1;
      // grows to 1.15 early in the flight, then eases down to the size of the count star
      var sc = t < 0.3 ? 0.45 + (1.15 - 0.45) * Math.sin((t / 0.3) * Math.PI / 2) : 1.15 + (endScale - 1.15) * ease((t - 0.3) / 0.7);
      frames.push({ offset: t, transform: 'translate(' + (x - 13) + 'px,' + (y - 13) + 'px) scale(' + sc.toFixed(3) + ') rotate(' + (288 * u).toFixed(1) + 'deg)', opacity: Math.min(1, t / 0.12) });
    }
    var anim = star.animate(frames, { duration: 720, easing: 'linear', fill: 'forwards' });
    var f = { icon: icon, star: star, landed: false, confirmed: false, done: false };
    flight = f;
    anim.onfinish = function () {
      f.landed = true;
      if (f.confirmed) { reveal(f); return; }
      // Waiting for the store: the star rests on the cart and breathes softly instead of freezing.
      f.breath = star.firstChild.animate([{ scale: 1 }, { scale: 1.07 }, { scale: 1 }], { duration: 1000, iterations: Infinity, easing: 'ease-in-out' });
    };
    // Safety: if the add fails or the tab pauses animations, give the cart back after a while.
    f.safety = setTimeout(function () { f.landed = true; reveal(f); }, 6000);
    return f;
  }
  // The theme's dot is hidden and replaced by the star: the dot is created on click, so it is the
  // earliest sign of an add (fly-to-cart.js removes it at once since it has nothing to animate).
  var hideDot = document.createElement('style');
  hideDot.textContent = 'fly-to-cart { display: none !important; }';
  document.head.appendChild(hideDot);
  function watch() {
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var r = records[i];
        if (r.type === 'childList') {
          for (var j = 0; j < r.addedNodes.length; j++) if (r.addedNodes[j].nodeName === 'FLY-TO-CART') { flyToCart(); break; }
        } else if (r.target.classList && r.target.classList.contains('cart-bubble--animating')) {
          confirmed();
        }
      }
    }).observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['class'] });
  }
  if (document.body) watch(); else document.addEventListener('DOMContentLoaded', watch);
  // The configurator announces its own adds (it has no theme dot).
  document.addEventListener('cart:updated', confirmed);

  /* 2. Star cursor over product photos -------------------------------------------------- */
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)');
  var PHOTO = 'product-card, .product-card, media-gallery, .product-media, .product-media-container, .product__media, .card-gallery, .yazne-config__preview-frame';
  var lx = 0, ly = 0, lt = 0, live = 0;
  document.addEventListener('pointermove', function (e) {
    if (!fine.matches || reduced.matches || e.pointerType !== 'mouse') return;
    if (!(e.target.closest && e.target.closest(PHOTO))) return;
    var now = performance.now();
    if (now - lt < 45 || Math.hypot(e.clientX - lx, e.clientY - ly) < 16 || live > 14) return;
    lt = now; lx = e.clientX; ly = e.clientY;
    var s = make('yz-sparkle', SPARK);
    live++;
    var size = 0.7 + Math.random() * 0.6;
    var ox = (Math.random() - 0.5) * 16, oy = (Math.random() - 0.5) * 12;
    var x = e.clientX - 9 + ox, y = e.clientY - 9 + oy;
    var a = s.animate([
      // Easing per segment (not on the whole run), so the sparkle actually holds its shine for a moment.
      { transform: 'translate(' + x + 'px,' + y + 'px) scale(0.2) rotate(0deg)', opacity: 0, easing: 'cubic-bezier(0.23, 1, 0.32, 1)' },
      { transform: 'translate(' + x + 'px,' + (y + 4) + 'px) scale(' + size + ') rotate(45deg)', opacity: 1, offset: 0.28, easing: 'cubic-bezier(0.5, 0, 0.75, 0)' },
      { transform: 'translate(' + (x + ox * 0.6) + 'px,' + (y + 18) + 'px) scale(0.15) rotate(90deg)', opacity: 0 }
    ], { duration: 760, fill: 'forwards' });
    a.onfinish = function () { s.remove(); live--; };
  }, { passive: true });
})();
